const UTCTimeNow = () => {
	return new Date().toISOString()
}

export default UTCTimeNow
